import { render, staticRenderFns } from "./ScenarioPushPullTab.vue?vue&type=template&id=0022a870"
import script from "./ScenarioPushPullTab.vue?vue&type=script&lang=js"
export * from "./ScenarioPushPullTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports